module.exports = __webpack_public_path__ + "assets/img/help_image03-2.003928aa.png";